import apiRequest from './client';

// Facturation superadmin — cf. prelote-backend/billing/. `updateCompany`
// (api/superadmin.js) reste la fonction utilisee pour bloquer/debloquer une
// company pour non-paiement (PATCH { billing_blocked }), pas dupliquee ici.

export const listBillingRates = () => apiRequest('/billing/rates/');

export const setBillingRate = (companyId, amount) =>
  apiRequest('/billing/rates/', { method: 'PATCH', body: { company_id: companyId, amount } });

export const generateInvoices = ({ periodStart, periodEnd }) =>
  apiRequest('/billing/invoices/generate/', {
    method: 'POST',
    body: { period_start: periodStart, period_end: periodEnd },
  });

export const updateInvoicePaid = (invoiceId, amountPaid) =>
  apiRequest(`/billing/invoices/${invoiceId}/`, { method: 'PATCH', body: { amount_paid: amountPaid } });

// Delai supplementaire (en jours, EN PLUS de due_date = period_end) qu'un
// superadmin peut accorder au cas par cas avant que le blocage automatique
// pour non-paiement ne s'applique (demande explicite 2026-09-19, "si le 30
// est arrive, le superadmin peut ajouter encore 5 jours de plus").
export const updateInvoiceGrace = (invoiceId, graceDays) =>
  apiRequest(`/billing/invoices/${invoiceId}/`, { method: 'PATCH', body: { grace_days: graceDays } });

// Encaissements par company : comptes, échéances et paiements.
export const listBillingAccounts = () => apiRequest('/billing/accounts/');
export const setBillingExpiration = (companyId, expiresAt) =>
  apiRequest(`/billing/accounts/${companyId}/`, {
    method: 'PATCH',
    body: { expires_at: expiresAt || null },
  });
export const listBillingPayments = (companyId) =>
  apiRequest(`/billing/accounts/${companyId}/payments/`);
export const recordBillingPayment = (companyId, { amountReceived, expiresAt, note }) =>
  apiRequest(`/billing/accounts/${companyId}/payments/`, {
    method: 'POST',
    body: { amount_received: amountReceived, expires_at: expiresAt, note },
  });

// Solde manuel saisi par le superadmin.
export const updateInvoiceManualBalance = (invoiceId, manualBalance) =>
  apiRequest(`/billing/invoices/${invoiceId}/`, {
    method: 'PATCH',
    body: { manual_balance: manualBalance },
  });


// Avances manuelles (réservées au vrai superadmin).
export const recordManualBillingCredit = (companyId, amount, note = '') =>
  apiRequest('/billing/credits/', {
    method: 'POST',
    body: { company_id: companyId, amount, note },
  });

export const listCompanyBillingCredits = (companyId) =>
  apiRequest(`/billing/credits/${companyId}/`);

// Journal des activités et annulation logique (audit conservé).
export const listBillingActivities = () => apiRequest('/billing/activities/');
export const cancelBillingActivity = (activityType, activityId, reason) =>
  apiRequest(`/billing/activities/${encodeURIComponent(activityType)}/${activityId}/cancel/`, {
    method: 'POST',
    body: { reason },
  });
